import http from '@axios'

export function getFlats(params) {
  return http({
    method: 'GET',
    url: 'flats/',
    params,
  })
}

export function getSingleFlat(id) {
  return http({
    method: 'GET',
    url: `flats/${id}/`,
  })
}

export function createFlat(data) {
  return http({
    method: 'POST',
    url: 'flats/',
    data,
  })
}

export function updateFlat(data) {
  return http({
    method: 'PATCH',
    url: `flats/${data.id}/`,
    data,
  })
}

export function getFlatPlannings(params) {
  return http({
    method: 'GET',
    url: 'flats/planning/',
    params,
  })
}

export function createFlatPlanning(data) {
  return http({
    method: 'POST',
    url: 'flats/planning/',
    data,
  })
}

export function editFlatPlanning(data) {
  return http({
    method: 'PATCH',
    url: `flats/planning/${data.id || data.get('id')}/`,
    data,
  })
}

export function deletePlanning(id) {
  return http({
    method: 'DELETE',
    url: `flats/planning/${id}`,
  })
}

export function getFlatsByApartment(params) {
  return http({
    method: 'GET',
    url: `apartments/${params.id}/flats/`,
    params,
  })
}

export function attachFlatsToPlannning(data) {
  return http({
    method: 'POST',
    url: `flats/planning/${data.id}/update_planning/`,
    data,
  })
}

export function getFlatCharacteristic() {
  return http({
    method: 'GET',
    url: 'flats/characteristic/',
  })
}

export function getFlatPlanningsByApartment(params) {
  return http({
    method: 'GET',
    url: `flats/planning/${params.id}/planning_by_apartment/`,
    params,
  })
}

export function createFlatCalculation(data) {
  return http({
    method: 'POST',
    url: '/flats/calculation/',
    data,
  })
}

export function updateFlatCalculation(data) {
  return http({
    method: 'PATCH',
    url: `/flats/calculation/${data.id}/`,
    data,
  })
}

export function deleteFlatCalculation(id) {
  return http({
    method: 'DELETE',
    url: `/flats/calculation/${id}/`,
  })
}

export function getFlatCOFile({
  id,
  ...params
}) {
  return http({
    method: 'GET',
    url: `/flats/kp/${id}`,
    params,
    timeout: 0,
  })
}

export function createFlatRegister(data) {
  return http({
    method: 'POST',
    url: '/flats/flat-register/',
    data,
  })
}


export function getFlatPercentages(data) {
  return http({
    method: 'GET',
    url: '/knowledge_base/payment-in-percent/get_all/',
    data,
  })
}

export function updatePricePerKv(data) {
  return http({
    method: 'PATCH',
    url: `/flats/${data.id}/update_flat_kv_m_price/`,
    data,
  })
}